import { Component, OnInit, Inject } from '@angular/core';
//import { Configuration } from 'src/app/Utilities/configurations';
// var Configuration = require('src/assets/app-config.json');
import { IEncounterData } from 'src/app/models/IEncounterData';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { IReportParameters } from 'src/app/models/IReportParameters';
import { configuration } from 'src/environments/environment';
import { DomSanitizer, SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl } from '@angular/platform-browser';
import { AESAlgorithm } from 'src/app/Utilities/Crypto/AESAlgorithm';

declare var $: any;
@Component({
  selector: 'app-show-ssrsreport',
  templateUrl: './show-ssrsreport.component.html',
  styleUrls: ['./show-ssrsreport.component.css']
})
export class ShowSSRSReportComponent implements OnInit {

  reportServer: string = configuration.reportsUrl;
  showParameters: string = "false";
  language: string = "en-us";
  parameters: any;
  reportUrl: string;
  public ifrmaesrc: any;
  public ifrmaeurl: any;
  constructor(public dialogRef: MatDialogRef<ShowSSRSReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IReportParameters,
    protected sanitizer: DomSanitizer
    , private crypto: AESAlgorithm,) {
    var iframesrcParams = '';
    var o = data.parameters;
    var x = Object.keys(o);
    var rptquerystr = '';
    Object.getOwnPropertyNames(o).forEach(function (val, id, array) {
      for (var i = 0; i < x.length; i++) {
        if (x.length != (id + 1))
          rptquerystr += val + '=' + encodeURIComponent(o[x[id]]) + '&';
        else
          rptquerystr += val + '=' + encodeURIComponent(o[x[id]]);
        break;
      }
    });

    let urlparma = "rname=" + data.reportUrl.split('/').pop() + "&" + rptquerystr + "&" + "ActiveStatus=" + data.ActiveStatus + "&" + "ReportName=" + data.ReportName + "&" + "ReportType=" + data.ReportType + "&" + "CatType=" + data.CatType+ "&" + "Ispdf=" + data.IsPdf;
    var rPathValues = configuration.reportsUrl + '?' + 'QP=' + encodeURIComponent(this.crypto.reqencryptor(urlparma));
    this.ifrmaesrc = this.sanitizer.bypassSecurityTrustResourceUrl(rPathValues);


    // this.reportUrl = encodeURIComponent(data.reportUrl)
    // this.parameters = data.parameters;
    // this.sanitizer.bypassSecurityTrustResourceUrl(this.ifrmaesrc.src);


  }
  onNoClick(): void {
    this.dialogRef.close();
  }


  ngOnInit() {
    //alert(Math.round(window.devicePixelRatio * 100));

  }

}
